// Region helpers — maps between ISO codes, country names and currencies
export const COUNTRY_OPTIONS = ['Australia', 'United Kingdom', 'Ireland', 'United States', 'New Zealand', 'Canada'];

const ISO_TO_COUNTRY = {
  AU: 'Australia', GB: 'United Kingdom', UK: 'United Kingdom', IE: 'Ireland',
  US: 'United States', NZ: 'New Zealand', CA: 'Canada'
};

const CURRENCY_TO_COUNTRY = {
  AUD: 'Australia', GBP: 'United Kingdom', EUR: 'Ireland',
  USD: 'United States', NZD: 'New Zealand', CAD: 'Canada'
};

export const COUNTRY_TO_CURRENCY = {
  Australia: 'AUD', 'United Kingdom': 'GBP', Ireland: 'EUR',
  'United States': 'USD', 'New Zealand': 'NZD', Canada: 'CAD'
};

export const countryFromIso = (code) => ISO_TO_COUNTRY[(code || '').toUpperCase()] || '';

// Viewer's country: detected value first, falling back to their currency choice
export const getViewerCountry = () => {
  const stored = localStorage.getItem('minted_country');
  if (stored) return stored;
  return CURRENCY_TO_COUNTRY[localStorage.getItem('minted_currency')] || '';
};

// Symbol to show next to a price in its listing currency
export const listingSymbol = (cur) => (
  { AUD: '$', GBP: '£', USD: 'US$', EUR: '€', NZD: 'NZ$', CAD: 'CA$' }[(cur || 'AUD').toUpperCase()] || '$'
);

// Which country a product belongs to (structured field, then legacy location text)
export const productCountry = (p) => {
  if (p?.country) return p.country;
  const loc = p?.location || '';
  for (const c of COUNTRY_OPTIONS) {
    if (c !== 'Australia' && loc.includes(c)) return c;
  }
  return 'Australia';
};
